export enum ScienceDocumentTypeEnum {
    Other = -1,
    Journal = 1,
    Conference = 3,
    Book = 4,
    BookChapter = 5,
    Thesis = 7,
    Repository = 8
}